import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "ui/components/table";
import { ExternalLink } from "lucide-react";
import { capitalizeFirstLetter } from "../utils/capitalize";
import IndustryTypeText from "components/industry/display";

const TOOLS = {
  project_management_tool: {
    label: "Project Management Tool",
  },
  communication_tool: {
    label: "Communication Tool",
  },
  development_tool: {
    label: "Development Tool",
  },
  whiteboarding: {
    label: "Whiteboarding",
  },
  analytics: {
    label: "Analytics",
  },
  testing: {
    label: "Testing",
  },
  dev_ops: {
    label: "DevOps",
  },
};

export function DynamicTable({
  title,
  headers,
  data,
  emptyMessage = "",
  defaultColumnClassName = "",
}) {
  if (!headers || headers.length === 0) {
    console.warn(
      "DynamicTable: 'headers' prop is required and must not be empty."
    );
    return null;
  }

  const hasData = data && data.length > 0;

  return (
    <div className="mb-8">
      {title && (
        <div className="flex items-center gap-2 mb-2">
          <h2 className="text-xl font-bold text-gray-800">{title}</h2>
        </div>
      )}

      {hasData ? (
        <Table>
          <TableHeader className="text-base bg-gray-100">
            <TableRow>
              {headers.map((header, index) => (
                <TableHead
                  key={index}
                  className={`text-left border ${
                    header.className || defaultColumnClassName
                  }`}
                >
                  {capitalizeFirstLetter(header.label)}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody className="text-base">
            {data.map((item, rowIndex) => (
              <TableRow key={rowIndex}>
                {headers.map((header, colIndex) => {
                  const value = item[header.key];

                  if (
                    title === "Basic Details" &&
                    header.key === "value" &&
                    item.label === "Industry"
                  ) {
                    return (
                      <TableCell
                        key={`${rowIndex}-${colIndex}`}
                        className={`text-left border 
                        ${
                          title === "Deliverables" &&
                          header.key === "deliverable"
                            ? "whitespace-normal break-words max-w-lg"
                            : ""
                        }
                        ${
                          title === "Deliverables" && header.key === "link"
                            ? "w-12"
                            : ""
                        }
                      `}
                      >
                        <IndustryTypeText value={value} />
                      </TableCell>
                    );
                  }

                  return (
                    <TableCell
                      key={`${rowIndex}-${colIndex}`}
                      className={`text-left border 
                        ${
                          title === "Deliverables" &&
                          header.key === "deliverable"
                            ? "whitespace-normal break-words max-w-lg"
                            : ""
                        }
                        ${
                          title === "Deliverables" && header.key === "link"
                            ? "w-12"
                            : ""
                        }
                      `}
                    >
                      {header.key === "link" && value ? (
                        <a href={value} target="_blank" title="Open link">
                          <ExternalLink size={18} />
                        </a>
                      ) : header.key === "deliverable" ? (
                        <span>{value}</span>
                      ) : (header.key === "type" || header.key === "tools") &&
                        TOOLS[value] ? (
                        <span>{capitalizeFirstLetter(TOOLS[value].label)}</span>
                      ) : (
                        capitalizeFirstLetter(value) || ""
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <p className="text-gray-700 text-base">{emptyMessage}</p>
      )}
    </div>
  );
}
